import React from 'react';
import _ from 'lodash';
import { useParameterizedQuery } from 'react-fetching-library';
import { Card, CardContent, CardHeader, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Tooltip } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import { getEmployeeApplications } from '../../../../../services/request';
import { useNavigate } from 'react-router-dom';

import { formatDateTime } from '../../../../../services/functions';

import toast from 'react-hot-toast';

export const ApplicationHistory = ({ rowData, handleAddNewTab }) => {
  const { query } = useParameterizedQuery(getEmployeeApplications);
  const navigate = useNavigate();
  const handleAddNewApplication = () => {
    navigate('/employee/applications', { state: { employeeData: rowData } });
  };

  const getApplication = async id => {
    const { payload, error, loading } = await query('GET', id);

    if (!error && !loading) {
      handleAddNewTab(payload);
    }

    if (error) {
      toast.error('Nie udało się pobrać aplikacji');
    }
  };

  return (
    <Stack spacing={2}>
      <Card>
        <CardHeader
          title="Historia aplikacji"
          action={
            <Tooltip title="dodaj nową aplikację do tego pracownika" onClick={() => handleAddNewApplication()}>
              <IconButton color="primary">
                <AddCircleIcon />
              </IconButton>
            </Tooltip>
          }/>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                  </TableCell>
                  <TableCell align="left">ID</TableCell>
                  <TableCell align="left">Data utworzenia</TableCell>
                  <TableCell align="left">Funkcja</TableCell>
                  <TableCell align="left">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowData && _.map(rowData.applications, item => <TableRow key={item.id}>
                  <TableCell align="center" width={150}>
                    <Stack direction="row" justifyContent="space-around">
                      <Tooltip title="Otwórz w nowej karcie">
                        <IconButton color="primary" onClick={() => getApplication(item.id)}>
                          <ContentPasteSearchIcon />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                  <TableCell align="left">{item.id}</TableCell>
                  <TableCell align="left">{formatDateTime(item.created_at)}</TableCell>
                  <TableCell align="left">{item.function_type_display}</TableCell>
                  <TableCell align="left">{item.state_name}</TableCell>
                </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Stack>
  );
};
